import React, { useEffect, useRef } from "react";
import Logobgtransparentblack from "../../images/DA_NoxZi/Logo-bg-transparent-black.png";
import { Link } from "react-router-dom";

export default function Footer() {
  const glowRef = useRef(null);

  useEffect(() => {
    const handleMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 24;
      const y = (e.clientY / window.innerHeight - 0.5) * 24;

      if (glowRef.current) {
        glowRef.current.style.transform = `translate(-50%, 0) translate(${x}px, ${y}px)`;
      }
    };

    window.addEventListener("mousemove", handleMove);
    return () => window.removeEventListener("mousemove", handleMove);
  }, []);

  return (
    <footer className="relative overflow-hidden bg-black text-white">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 opacity-[0.03] [background-image:radial-gradient(#fff_0.7px,transparent_0.7px)] [background-size:18px_18px]" />

        <div
          ref={glowRef}
          className="absolute left-1/2 top-20 h-[600px] w-[600px] rounded-full bg-[#c9a35f]/20 blur-3xl transition-transform duration-200"
        />

        <div className="absolute bottom-10 right-[10%] h-80 w-80 rounded-full bg-white/5 blur-3xl" />

        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="select-none font-asap text-[20vw] font-[700] tracking-[-0.08em] text-white/[0.03]">
            NOXZI
          </h1>
        </div>

        <div className="absolute left-1/2 top-0 h-px w-[70%] -translate-x-1/2 bg-gradient-to-r from-transparent via-[#c9a35f]/40 to-transparent" />
      </div>

      <div className="relative mx-auto max-w-7xl px-6 py-28">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="space-y-6">
            <img
              src={Logobgtransparentblack}
              alt="NoxZi Logo"
              className="h-12 w-12 invert"
            />

            <p className="max-w-xs font-asap text-[15px] leading-relaxed text-white/70">
              Nous concevons des applications mobiles sur mesure, pensées pour
              transformer votre vision en produit concret, performant et durable.
            </p>

            <div className="h-px w-20 bg-gradient-to-r from-[#c9a35f] to-transparent" />
          </div>

          <div className="space-y-6">
            <h3 className="font-asap text-[12px] uppercase tracking-[0.28em] text-[#d1a75f]">
              Navigation
            </h3>

            <ul className="space-y-3 font-asap text-[14px]">
              {[
                { label: "Accueil", href: "#top" },
                { label: "Services", href: "#services" },
                { label: "Bénéfices", href: "#benefices" },
                { label: "Contact", href: "#contact" },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="group relative text-white/70 transition-all duration-300 hover:text-white"
                  >
                    {item.label}
                    <span className="absolute left-0 -bottom-1 h-[1px] w-0 bg-gradient-to-r from-[#c9a35f] to-transparent transition-all duration-300 group-hover:w-full" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-6">
            <h3 className="font-asap text-[12px] uppercase tracking-[0.28em] text-[#d1a75f]">
              Services
            </h3>

            <ul className="space-y-3 font-asap text-[14px]">
              {[
                "Applications mobiles",
                "React Native",
                "Design UI/UX",
                "Accompagnement",
              ].map((item) => (
                <li key={item}>
                  <a
                    href="#services"
                    className="group relative text-white/70 transition-all duration-300 hover:text-white"
                  >
                    {item}
                    <span className="absolute left-0 -bottom-1 h-[1px] w-0 bg-gradient-to-r from-[#c9a35f] to-transparent transition-all duration-300 group-hover:w-full" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-6">
            <h3 className="font-asap text-[12px] uppercase tracking-[0.28em] text-[#d1a75f]">
              Contact
            </h3>

            <div className="space-y-4 font-asap text-[14px] text-white/70">
              <div>
                <p className="mb-1 text-white/40">Email</p>
                <a href="mailto:contact@noxzi.com" className="text-white hover:underline">
                  contact@noxzi.com
                </a>
              </div>

              <div>
                <p className="mb-1 text-white/40">Téléphone</p>
                <a href="tel:+33603599952" className="text-white hover:underline">
                  +33 6 03 59 99 52
                </a>
              </div>

              <div>
                <p className="mb-1 text-white/40">Localisation</p>
                <p>Chambéry, France</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-24 flex flex-col items-center justify-between gap-6 border-t border-white/10 pt-8 md:flex-row">
          <p className="text-center font-asap text-[12px] text-white/50 md:text-left">
            <Link to="/mentions-legales" className="px-3 hover:text-white">
              Mentions légales
            </Link>
            <Link to="/cgu" className="px-3 hover:text-white">
              CGU
            </Link>
            <Link to="/cgv" className="px-3 hover:text-white">
              CGV
            </Link>
            <Link to="/cgs" className="px-3 hover:text-white">
              CGS
            </Link>
            <Link to="/politique-confidentialité" className="px-3 hover:text-white">
              Politique de Confidentialité
            </Link>
            © 2025 - 2026 NoxZi. Tous droits réservés.
          </p>

          <div className="flex gap-6">
            {[
              {
                label: "LinkedIn",
                path: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
              },
              {
                label: "GitHub",
                path: "M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z",
              },
              {
                label: "X",
                path: "M18.244 2H21.5l-7.11 8.129L22.75 22h-6.545l-5.126-6.697L5.22 22H1.96l7.604-8.69L1.5 2h6.708l4.634 6.109L18.244 2zm-1.148 18h1.804L7.23 3.895H5.293L17.096 20z",
              },
            ].map((item) => (
              <a
                key={item.label}
                href="#"
                className="group relative text-white/50 transition-all duration-300 hover:text-white"
              >
                <span className="absolute inset-0 rounded-full bg-[#c9a35f]/20 opacity-0 blur-md transition duration-300 group-hover:opacity-100" />
                <span className="sr-only">{item.label}</span>
                <svg className="relative z-10 h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d={item.path} />
                </svg>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
